import ScrollToContent from './ScrollToContent';

export default ScrollToContent;
